import { useRef, useState } from 'react';

const useAddSeries = () => {
  const [isOpen, setIsOpen] = useState(false);
  const addSeriesButtonRef = useRef<HTMLButtonElement | null>(null);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const toggleModal = () => setIsOpen(!isOpen);

  return {
    isOpen,
    openModal,
    closeModal,
    toggleModal,
    addSeriesButtonRef,
  };
};

export default useAddSeries;
